module.exports = __webpack_public_path__ + "img/ErrorImage.3d4bbd79.png";